import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloProvider } from 'react-apollo'
import { SubscriptionClient, addGraphQLSubscriptions } from 'subscriptions-transport-ws'

import { I18nextProvider } from 'react-i18next'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import routes from './routes'
import config from './config'
import i18n from './i18n'

//import './index.css'

const wsClient = new SubscriptionClient(config.subscriptionAPI, {
  lazy: true,
  reconnect: true
})

const networkLink = new HttpLink({
  uri: config.simpleAPI
})

const middlewareLink = setContext(() => ({
  headers: {
    authorization: `Bearer ${localStorage.getItem('auth0IdToken')}` || null,
    'x-hasura-admin-secret': 12344321
  }
}))

// use with apollo-client
const link = middlewareLink.concat(networkLink)

const networkLinkWithSubscriptions = addGraphQLSubscriptions(link, wsClient)

const defaultOptions: DefaultOptions = {
      watchQuery: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'ignore',
      },
      query: {
        fetchPolicy: 'no-cache',
        errorPolicy: 'all',
      },
    }

export const client = new ApolloClient({
  link: networkLinkWithSubscriptions,
  cache: new InMemoryCache(),
  defaultOptions: defaultOptions
})

ReactDOM.render(
  <ApolloProvider client={client}>
    <I18nextProvider i18n={i18n}>
      <MuiThemeProvider>
        <Router>
          {routes}
        </Router>
      </MuiThemeProvider>
    </I18nextProvider>
  </ApolloProvider>,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// src/index.js